var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { LessonCard } from './LessonCard';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1id8qcr" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  margin-left: 13px;\n  margin-top: 24px;\n  overflow-x: scroll;\n\n  @media (min-width: 576px) {\n    flex-wrap: wrap;\n    margin-left: 22px;\n    overflow-x: initial;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  margin-left: 13px;\n  margin-top: 24px;\n  overflow-x: scroll;\n\n  @media (min-width: 576px) {\n    flex-wrap: wrap;\n    margin-left: 22px;\n    overflow-x: initial;\n  }\n"])));
var LessonCardsList = function (_a) {
    var _b = _a.cards, cards = _b === void 0 ? [] : _b;
    return (_jsx(Container, { children: cards.map(function (card) { return (_jsx(LessonCard, __assign({}, card), card.id)); }) }, void 0));
};
export { LessonCardsList };
var templateObject_1;
